import {FeatureAComponent} from "./feature-a.component";

const FEATURE_A_STATES = [{
  name: 'blank.feature-module',
  url: '/featureAModule',
  component: FeatureAComponent
}];

export { FEATURE_A_STATES };
